import { Color3, Mesh, MeshBuilder, StandardMaterial } from 'babylonjs' // This is core lib
import { Context3D } from './3d-context'

// THIS IS PLAYGROUND

/**
 * Add example box object to scene
 */
export function addExampleObject(context = Context3D.get()) {
  if (!context.scene) return

  Mesh.CreateBox('box', 10, context.scene, false, Mesh.FRONTSIDE)
}

/**
 * Create ground object if you need it
 */
export function setupFloor(context = Context3D.get()) {
  if (!context.scene) return

  // SETUP GROUND
  const floor = Mesh.CreateGround(
    'floor_mesh',
    1000,
    1000,
    1,
    context.scene,
    true
  )

  // const groundMaterial = new PBRMaterial('ground_material', context.scene)
  const floorMaterial = new StandardMaterial('floor_material', context.scene)
  // groundMaterial.roughness = 0.5
  // groundMaterial.metallic = 1
  floorMaterial.diffuseColor = Color3.FromHexString('#9A9A9A')
  floor.receiveShadows = true
  // material.reflectionTexture = new CubeTexture("./textures/TropicalSunnyDay", scene);
  // @ts-ignore
  // material.reflectionTexture.boundingBoxSize = new BABYLON.Vector3(1000, 1000, 1000);
  // material.disableLighting = true;
  floor.material = floorMaterial
  // ground.position.y += 0.2

  const skybox = MeshBuilder.CreateBox(
    'skybox_mesh',
    { size: 500 },
    context.scene
  )
  const skyboxMaterial = new StandardMaterial('skybox_material', context.scene)
  skyboxMaterial.backFaceCulling = false
  // skyboxMaterial.reflectionTexture = texture
  // skyboxMaterial.reflectionTexture.coordinatesMode = Texture.SKYBOX_MODE
  skyboxMaterial.diffuseColor = Color3.FromHexString('#FFFFFF')
  skybox.material = skyboxMaterial
}

/**
 * show/hide ground object
 */
export function toggleFloor(context = Context3D.get()) {
  if (!context.scene) return

  const floor_mesh = context.scene.getMeshByID('floor_mesh')

  if (floor_mesh?.isEnabled()) {
    floor_mesh?.setEnabled(false)
  } else {
    floor_mesh?.setEnabled(true)
  }
}
